










































































import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {BasketDto, CouponDto} from "@swagger";

@Component({
  components: {}
})
export default class DiscountBanner extends BasicComponent {

  open: boolean = false;
  hover: boolean = false;

  get coupons(): Array<CouponDto> {
    return this.$store.getters.coupons;
  }

  get hasCoupons() {
    return this.coupons && this.coupons.length > 0;
  }

  get nextCouponIndex() {
    let i = 0;
    for (; i < this.coupons.length; i++) {
      if (this.coupons[i].minimumValue > this.subtotal) break;
    }
    return i;
  }

  get hasNextCoupon() {
    return this.nextCouponIndex < this.coupons.length;
  }

  get nextCoupon() {
    if (!this.hasNextCoupon) return null;
    return this.coupons[this.nextCouponIndex];
  }

  get maxGoal(): number {
    if (!this.hasCoupons) return 0.0;
    return this.coupons[this.coupons.length - 1].minimumValue;
  }

  get basket(): BasketDto {
    return this.$store.getters.basket;
  }

  get subtotal(): number {
    const basket = this.basket;
    if (!basket) return 0.0;
    return basket.subtotal;
  }

  couponActive(coupon: CouponDto): boolean {
    return this.subtotal >= coupon.minimumValue;
  }

  percentageOf(value: number): number {
    if (this.maxGoal === 0.0) return 0;
    return Math.min(100, value * 100 / this.maxGoal);
  }

  get discountPercentage(): number {
    return this.percentageOf(this.subtotal);
  }

  calcMeterLeft(perc: number): string {
    const offset = (50 - perc) * 15 / 50;
    return "calc(" + perc + "% + (" + offset + "px))";
  }

  get expiryDate(): string {
    const dates = this.coupons.map(coupon => coupon.activeUntil).filter(el => el != null).sort();
    if (dates.length === 0) return null;
    return dates[0];
  }

  toggleOpen() {
    if (this.hover) return;
    this.open = !this.open;
  }

  onHover(val) {
    if (val && !this.hover) {
      this.trackEvent("Gutschein", "Gutscheinliste geöffnet")
    }
    if (this.isMobile) return;
    this.hover = val;
  }

  get isOpen() {
    return this.open || this.hover;
  }

}

